module.exports = __webpack_public_path__ + "static/media/small-trigangle.050cc8ad.png";